export default __webpack_public_path__ + "static/media/deskReservationHome.3e04c56f.png";